import { FC, useEffect, useState } from 'react'
import { gemoji } from 'gemoji'
import { toast } from 'react-toastify'

import { Button as btn } from '../uiKit'
import closeIcon from '../../assets/svg/icon_close_cross.svg'
import { EmojiData, StickerFile } from '../../pages/AddAnimatedStickers'

import './styles.scss'

interface AnimatedStickerEditorProps {
  editableSticker: File
  onDone: (sticker: StickerFile) => void
  onClose: () => void
}

const Button = btn as any

export const AnimatedStickerEditor: FC<AnimatedStickerEditorProps> = ({
  editableSticker,
  onDone,
  onClose,
}) => {
  const [imageScr, setImageScr] = useState<string>('')
  const [correspondingEmoji, setCorrespondingEmoji] =
    useState<EmojiData | null>(null)

  const done = () => {
    if (!correspondingEmoji) {
      toast('Please select an emoji to continue adding this sticker')
      return
    }

    if (correspondingEmoji)
      onDone({
        id: new Date().getTime(),
        file: editableSticker,
        isAnimated: true,
        emoji: {
          emojiName: correspondingEmoji.emojiName,
          emoji: correspondingEmoji.emoji,
        },
        sticker: imageScr,
      })
  }

  useEffect(() => {
    const videoUrl = URL.createObjectURL(editableSticker)

    setImageScr(videoUrl)
  }, [])

  return (
    <div className="aimated-sticker-editor">
      <button
        type="button"
        className="aimated-sticker-editor--close"
        onClick={onClose}
      >
        <img src={closeIcon} alt="" />
      </button>

      <div className="aimated-sticker-editor--panel">
        <tgs-player
          autoplay
          loop
          mode="normal"
          src={URL.createObjectURL(editableSticker)}
        ></tgs-player>

        {/* <video
          ref={(ref) => {
            if (ref) {
              setTimeout(() => {
                ref.volume = 0
              }, 100)
            }
          }}
          autoPlay
          loop
          src={imageScr}
        >
          <track kind="captions" />
        </video> */}

        <div className="aimated-sticker-editor--toolbar">
          <div className="emoji-matcher">
            {gemoji.map((e) => {
              const name = e.names[0]
              return (
                <button
                  onClick={() =>
                    setCorrespondingEmoji({ emoji: e.emoji, emojiName: name })
                  }
                  type="button"
                  key={name}
                  className={`emoji-matcher--btn ${
                    name === correspondingEmoji?.emojiName
                      ? 'emoji-matcher--btn-active'
                      : ''
                  }`}
                >
                  {e.emoji}
                </button>
              )
            })}
          </div>

          <div className="aimated-sticker-editor--done-btn">
            <Button onClick={done}>Done</Button>
          </div>
        </div>
      </div>
    </div>
  )
}
